/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseregistrationEnrollmentCancel202,
  PostApiV1CourseregistrationEnrollmentCancel400,
  PostApiV1CourseregistrationEnrollmentCancel401,
  PostApiV1CourseregistrationEnrollmentCancel500,
  PostApiV1CourseregistrationEnrollmentCancelMutationRequest,
  PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentCancel.ts";
import { courseRegistrationCancelEnrollmentRequestViewModelSchema } from "../courseRegistrationCancelEnrollmentRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1CourseregistrationEnrollmentCancel202Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancel202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseregistrationEnrollmentCancel400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancel400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseregistrationEnrollmentCancel401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancel401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseregistrationEnrollmentCancel500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancel500>;

export const postApiV1CourseregistrationEnrollmentCancelMutationRequestSchema =
  z.lazy(
    () => courseRegistrationCancelEnrollmentRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancelMutationRequest>;

export const postApiV1CourseregistrationEnrollmentCancelMutationResponseSchema =
  z.lazy(
    () => postApiV1CourseregistrationEnrollmentCancel202Schema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentCancelMutationResponse>;
